module.exports = __webpack_public_path__ + "static/media/46.086d4c18.png";